import {
  getHomePageTopList,
  getHomePageOtherList,
  getHomePageVoiceList,
  getHomePageTopTen,
  getHotVideo
} from '../services/index'
import {
  NHomePage,
  EGetHomePageTopList,
  EGetHomePageOtherList,
  EGetHomePageVoiceList,
  EGetHomePageTopTen,
  EGetHotVideo,
  RSetState,
  RSetVoiceList
} from './constants'
import _ from 'lodash'

export default {
  namespace: NHomePage,
  state: {
    topList: null,
    otherList: [],
    innerVoice: [],
    topTen: null,
    hotVideo: []
  },
  effects: {
    async [EGetHomePageTopList]({ payload }, { call, reducer, select }){
      let data = await call(getHomePageTopList, payload)
      reducer(RSetState, {topList: data})
    },
    async [EGetHomePageOtherList]({ payload }, { call, reducer, select }){
      let data = await call(getHomePageOtherList, payload)
      let list = []
      if(data){
        data.map((vo, index) => {
          if(vo.name !== '行政'){
            list.push(vo)
          }
        })
      }
      reducer(RSetState, {otherList: list})
    },
    async [EGetHomePageVoiceList]({ payload }, { call, reducer, select }){
      let data = await call(getHomePageVoiceList, payload)
      reducer(RSetVoiceList, data)
    },
    async [EGetHomePageTopTen]({ payload }, { call, reducer, select }){
      let data = await call(getHomePageTopTen, payload)
      reducer(RSetState, {topTen: data})
    },
    async [EGetHotVideo]({ payload }, { call, reducer, select }){
      let data = await call(getHotVideo, payload)
      reducer(RSetState, {hotVideo: data})
    },
  },
  reducers: {
    RSetState(state,{ payload }){
      return {
        ...state,
        ...payload
      }
    },
    RSetVoiceList(state,{ payload }){
      let list = [{data: []},{data: []}, {data: []}]
      if(payload){
        _.forEach(payload.data, ( vo, index ) => {
          if(index<3){
            list[index].data.push(vo)
          }
          if(index>=3 && index<6){
            list[index - 3].data.push(vo)
          }
          if(index>=6 && index<9){
            list[index - 6].data.push(vo)
          }
          if(index>=9 && index<12){
            list[index - 9].data.push(vo)
          }
        })
      }
      return {
        ...state,
        innerVoice: list.concat()
      }
    }
  }
}